export type SubscriptionPlanId = 'starter' | 'growth' | 'scale'

export interface SubscriptionPlan {
  id: SubscriptionPlanId
  name: string
  price: number
  minutes: number
  overageRate: number
  description: string
  recommended?: boolean
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'starter',
    name: 'Starter',
    price: 14.99,
    minutes: 100,
    overageRate: 0.15,
    description: 'Including 100 monthly voice minutes for AI-powered call answering.',
    recommended: true,
  },
]

export const DEFAULT_SUBSCRIPTION_PLAN_ID: SubscriptionPlanId = 'starter'

export interface PromoCodeResult {
  code: string
  description: string
  firstMonthDiscountPercent: number
}

const PROMO_CODES: Record<string, PromoCodeResult> = {
  VEXU20: {
    code: 'VEXU20',
    description: '20% off your first month',
    firstMonthDiscountPercent: 20,
  },
}

export function validatePromoCode(value: string): PromoCodeResult | null {
  return PROMO_CODES[value.trim().toUpperCase()] ?? null
}

export function getSubscriptionPlan(id: SubscriptionPlanId): SubscriptionPlan {
  return (
    SUBSCRIPTION_PLANS.find((plan) => plan.id === id) ?? SUBSCRIPTION_PLANS[0]
  )
}

export function formatCurrency(value: number): string {
  return `$${value.toFixed(2)}`
}
